export default {
  'common.save': 'Simpan',
  'common.cancel': 'Batal',
  'common.delete': 'Hapus',
  'common.edit': 'Edit',
  'common.confirm': 'Konfirmasi',
  'common.close': 'Tutup',
  'common.search': 'Cari',
  'common.loading': 'Memuat...',
  'common.processing': 'Memproses...',
  'common.submit': 'Kirim',
  'common.back': 'Kembali',
  'common.next': 'Berikutnya',
  'common.previous': 'Sebelumnya',
  'common.upload': 'Unggah',
  'common.download': 'Unduh',
  'common.downloadAll': 'Unduh semua',
  'common.refresh': 'Segarkan',
  'common.retry': 'Coba lagi',
  'common.copy': 'Salin',
  'common.copied': 'Tersalin',
  'common.selectAll': 'Pilih semua',
  'common.clear': 'Bersihkan',
  'common.clearAll': 'Bersihkan semua',
  'common.apply': 'Terapkan',
  'common.reset': 'Atur ulang',
  'common.filter': 'Filter',
  'common.sort': 'Urutkan',
  'common.export': 'Ekspor',
  'common.import': 'Impor',
  'common.preview': 'Pratinjau',
  'common.view': 'Lihat',
  'common.add': 'Tambah',
  'common.remove': 'Hapus',
  'common.rename': 'Ganti nama',
  'common.share': 'Bagikan',
  'common.settings': 'Pengaturan',
  'common.logout': 'Keluar',
  'common.profile': 'Profil',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.ok': 'OK',
  'common.areYouSure': 'Apakah Anda yakin?',
  'common.actionCannotBeUndone': 'Tindakan ini tidak dapat dibatalkan.',
  'common.noData': 'Tidak ada data',
  'common.noResultsFound': 'Tidak ada hasil ditemukan',
  'common.somethingWentWrong': 'Terjadi kesalahan',
  'common.pleaseTryAgain': 'Silakan coba lagi',
  'common.success': 'Berhasil',
  'common.error': 'Kesalahan',
  'common.warning': 'Peringatan',
  'common.info': 'Info',
  'common.optional': 'Opsional',
  'common.required': 'Wajib diisi',
  'common.name': 'Nama',
  'common.title': 'Judul',
  'common.description': 'Deskripsi',
  'common.status': 'Status',
  'common.actions': 'Tindakan',
  'common.date': 'Tanggal',
  'common.time': 'Waktu',
  'common.createdAt': 'Dibuat',
  'common.updatedAt': 'Diperbarui',
  'common.type': 'Jenis',
  'common.size': 'Ukuran',
  'common.file': 'Berkas',
  'common.folder': 'Folder',
  'common.files': 'Berkas',
  'common.folders': 'Folder',
  'common.all': 'Semua',
  'common.none': 'Tidak ada',
  'common.send': 'Kirim',
  'common.sending': 'Mengirim...',
  'common.new': 'Baru',
  'common.create': 'Buat',
  'common.duplicate': 'Duplikat',
  'common.move': 'Pindahkan',
  'common.moveTo': 'Pindahkan ke',
  'common.selectFile': 'Pilih berkas',
  'common.chooseFile': 'Pilih berkas',
  'common.dragDropFilesHere': 'Seret dan lepas berkas di sini',
  'common.or': 'atau',
  'common.browse': 'Jelajahi',
  'common.continue': 'Lanjutkan',
  'common.skip': 'Lewati',
  'common.done': 'Selesai',
  'common.finish': 'Selesai',
  'common.start': 'Mulai',
  'common.stop': 'Berhenti',
  'common.pause': 'Jeda',
  'common.resume': 'Lanjutkan',
  'common.enabled': 'Diaktifkan',
  'common.disabled': 'Dinonaktifkan',
  'common.active': 'Aktif',
  'common.inactive': 'Tidak aktif',
  'common.draft': 'Draf',
  'common.published': 'Diterbitkan',
  'common.archive': 'Arsipkan',
  'common.unarchive': 'Batalkan arsip',
  'common.favourite': 'Favorit',
  'common.favourites': 'Favorit',
  'common.pin': 'Sematkan',
  'common.unpin': 'Lepas sematan',
  'common.expand': 'Perluas',
  'common.collapse': 'Ciutkan',
  'common.showMore': 'Tampilkan lebih banyak',
  'common.showLess': 'Tampilkan lebih sedikit',
  'common.language': 'Bahasa',
  'common.darkMode': 'Mode gelap',
  'common.lightMode': 'Mode terang',
  'common.help': 'Bantuan',
  'common.feedback': 'Masukan',
  'common.notifications': 'Notifikasi',
  'common.rows': 'Baris',
  'common.column': 'Kolom',
  'common.total': 'Total',
  'common.page': 'Halaman',
  'common.of': 'dari',
  'common.notes': 'Catatan',
};
